import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomepageEventBanner } from '../../core/models/homepage-event-banner.model';
import { CxIconComponent } from '../icon/cx-icon.component';

@Component({
  selector: 'app-homepage-event-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, CxIconComponent],
  templateUrl: './homepage-event-banner.component.html',
  styleUrl: './homepage-event-banner.component.scss',
})
export class HomepageEventBannerComponent
  implements OnChanges, OnInit, OnDestroy
{
  @Input() banner: HomepageEventBanner | null = null;

  activeBanner: HomepageEventBanner | null = null;
  private statusRefreshTimer: number | null = null;

  ngOnChanges(): void {
    this.activeBanner = this.banner ? { ...this.banner } : null;
    this.refreshStatusTimer();
  }

  ngOnInit(): void {
    if (!this.activeBanner && this.banner) {
      this.activeBanner = { ...this.banner };
    }
    this.refreshStatusTimer();
  }

  ngOnDestroy(): void {
    this.clearStatusRefreshTimer();
  }

  private refreshStatusTimer(): void {
    if (!this.activeBanner) {
      this.clearStatusRefreshTimer();
      return;
    }

    this.refreshStatus();
    if (this.activeBanner && this.statusRefreshTimer === null) {
      this.statusRefreshTimer = window.setInterval(
        () => this.refreshStatus(),
        30_000
      );
    }
  }

  private clearStatusRefreshTimer(): void {
    if (this.statusRefreshTimer !== null) {
      window.clearInterval(this.statusRefreshTimer);
      this.statusRefreshTimer = null;
    }
  }

  get rsvpReturnUrl(): string {
    if (!this.activeBanner) {
      return '/';
    }

    return `/profile/view-virtual-event/${encodeURIComponent(
      this.activeBanner.hostTag
    )}/${encodeURIComponent(String(this.activeBanner.eventId))}?autoRSVP=true`;
  }

  formatEventTime(banner: HomepageEventBanner): string {
    try {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZone: banner.timezoneId,
        timeZoneName: 'short',
      }).format(new Date(banner.startsAt));
    } catch {
      return banner.startsAt;
    }
  }

  private refreshStatus(): void {
    if (!this.activeBanner) {
      this.clearStatusRefreshTimer();
      return;
    }

    const startsAt = Date.parse(this.activeBanner.startsAt);
    const endsAt = Date.parse(this.activeBanner.endsAt);
    const now = Date.now();

    if (
      !Number.isFinite(startsAt) ||
      !Number.isFinite(endsAt) ||
      now >= endsAt
    ) {
      this.activeBanner = null;
      this.clearStatusRefreshTimer();
      return;
    }

    this.activeBanner = {
      ...this.activeBanner,
      status: now < startsAt ? 'UPCOMING' : 'LIVE',
    };
  }
}
